"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var adjustColorConfig_1 = require("./adjustColorConfig");
exports.getColorConfig = adjustColorConfig_1.getColorConfig;
var globalLegend_1 = require("./globalLegend");
exports.getLegendData = globalLegend_1.getLegendData;
exports.mergeLegendData = globalLegend_1.mergeLegendData;
exports.createLegend = globalLegend_1.createLegend;
var globalAxis_1 = require("./globalAxis");
exports.getAxisData = globalAxis_1.getAxisData;
exports.mergeAxisScale = globalAxis_1.mergeAxisScale;
exports.createAxis = globalAxis_1.createAxis;
exports.axesLayout = globalAxis_1.axesLayout;
exports.drawYGrid = globalAxis_1.drawYGrid;
var globalTooltip_1 = require("./globalTooltip");
exports.showTooltip = globalTooltip_1.showTooltip;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/combo-plots/util/index.js
// module id = 847
// module chunks = 37